import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService"; 

class ManagementUserService extends AxiosService {
    constructor() {
        super('management');
    }

    getKitRemoteState = async ({ cancelToken = null } = {}) => {
        return await this.get(
            `/management-user/kit-state`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                cancelToken: cancelToken
            }
        );
    }

    setKitRemoteState = async (sessionData, flag, { cancelToken = null } = {}) => {
        return await this.get(
            `/management-user/kit-editor/${flag}`,
            {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                    socket: sessionData.socket,
                    browser: sessionData.browser,
                    tab: sessionData.tab
                },
                cancelToken: cancelToken
            }
        );
    }

}
export default new ManagementUserService();
